import * as styles from "./SolidButton.styles";
var getCustomHoverStyle = function getCustomHoverStyle(textColorMode) {
  return textColorMode === 'dark' ? styles.hoverDarkTextModeFilter : styles.hoverLightTextModeFilter;
};
export var getHoverStyle = function getHoverStyle(textColorMode, customBackgroundColor) {
  return customBackgroundColor ? getCustomHoverStyle(textColorMode) : styles.hoverStandard;
};
export var getCustomBackgroundStyle = function getCustomBackgroundStyle(customBackgroundColor) {
  return customBackgroundColor ? {
    backgroundColor: customBackgroundColor
  } : {};
};